export default __webpack_public_path__ + "static/media/dealsTag.0a99aa28.svg";